import React from "react";

export const RequiredIcon = () => {
  return (
    <sup
      style={{
        color: "#f44336",
        fontWeight: "bold",
        marginLeft: "0.5rem",
      }}
    >
      *
    </sup>
  );
};
